import { CompoundEntityRef, Entity, parseEntityRef } from '@backstage/catalog-model';

/**
 * Parses the owners annotation into user entity refs. Still supports the old
 * `simcorp.com/system-owners` annotation.
 *
 * @public
 */
export function getAnnotatedOwnerRefs(entity: Entity): CompoundEntityRef[] {
  const annotations = entity.metadata.annotations;
  const ownersAnnotation =
    annotations?.['simcorp.com/owners'] ??
    annotations?.['simcorp.com/system-owners'];
  return (ownersAnnotation ?? '')
    .split(',')
    .map(x => x.trim())
    .filter(x => x)
    .map(x => x.replaceAll('@', '_'))
    .map(x => parseEntityRef(x, { defaultKind: 'user' }));
}
